/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Radio = require('backbone.radio');

var BreadcrumbView = require('common/views/BreadcrumbView');
var modelGet = require('common/util/modelGet');
var EntityHeaderBarView = require('../../common/views/EntityHeaderBarView');

var EntityOfficerChangeApplication = require('../../amendments/forms/EntityOfficerChangeApplication');

var tmplNonDepEntityAddOfficerView = require('../templates/NonDepEntityAddOfficerView.hbs');

module.exports = Marionette.LayoutView.extend({
  template: tmplNonDepEntityAddOfficerView,

  className: 'nondep-entity-add-officer-view container-fluid',

  ui: {
    headerBarContainer: '.header-bar-container',
    breadCrumbContainer: '.breadcrumb-container',
    entityOfficerChangeFormContainer: '.entity-officer-change-form-container'
  },

  regions: {
    headerBarContainer: '@ui.headerBarContainer',
    breadCrumbContainer: '@ui.breadCrumbContainer',
    entityOfficerChangeFormContainer: '@ui.entityOfficerChangeFormContainer'
  },

  onBeforeShow: function() {
    var entityId = this.model.get('entityId');
    var entityName = modelGet(this.model, 'entityIdentifiers.entityName');

    this.showChildView(
      'headerBarContainer',
      new EntityHeaderBarView({
        model: new Backbone.Model(this.model.get('entityIdentifiers'))
      })
    );

    this.showChildView(
      'breadCrumbContainer',
      new BreadcrumbView({
        breadcrumbs: [
          {
            text: 'Home',
            link: '#nondep/dashboard'
          },
          {
            text: entityName,
            link: '#nondep/entity/' + entityId + '/dashboard'
          },
          {
            text: 'Add Officer'
          }
        ]
      })
    );

    this.showChildView(
      'entityOfficerChangeFormContainer',
      new EntityOfficerChangeApplication({
        viewMode: this.options.viewMode,
        isAmendment: false,
        model: new Backbone.Model({
          officerTypes: this.model.get('officerTypes'),
          entityId: entityId,
          isOfficerConvicted: modelGet(this.model, 'isOfficerConvicted'),
          isOfficerConvictedDocument: modelGet(this.model, 'isOfficerConvictedDocument')
        })
      })
    );

    Radio.channel('nd:submit-case-management-change').on('submit', function() {
      Radio.channel('navigate').trigger('show:int:nd:entity-dashboard', entityId);
    });
  }
});
